import React from 'react'
import Header from '../Component/Header/Header'
import Footer from '../Component/Footer/Footer'
import ContactMain from '../Component/ContactMain/ContactMain'

function contact() {
  return (
    <>
      <Header/>
      <ContactMain/>
      <Footer/>
    </>
  )
}

export default contact